module.exports = __webpack_public_path__ + "6fd5f4a49584640122a26df19f5d69b1.svg";